import { Box, IconButton, Stack } from '@mui/material'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import { COLORS } from 'app-constants'

// this component is only responsible for rendering the buttons, it does not handle the specific businss logic of each button
const BulkActionBar = ({
  isOpen,
  buttons,
  onDismiss,
}: {
  isOpen: boolean
  buttons: React.ReactNode[]
  onDismiss: () => void
}) => {
  return (
    <Box
      sx={{
        overflowX: 'auto',
        visibility: isOpen ? 'visible' : 'hidden',
      }}>
      <Stack
        borderRadius="8px"
        p={1}
        direction="row"
        alignItems="center"
        width="fit-content"
        spacing={2}
        sx={{
          backgroundColor: COLORS.GRAY_8,
        }}>
        <IconButton onClick={onDismiss}>
          <CloseOutlinedIcon
            sx={{
              color: COLORS.GRAY_3,
            }}
          />
        </IconButton>
        {buttons.map((button, index) => {
          return <Stack key={index}>{button}</Stack>
        })}
      </Stack>
    </Box>
  )
}

export default BulkActionBar
